import { call, put } from 'redux-saga/effects';
import * as receiptActions from '../actions/receiptActionsHelper';
import * as api from '../../api';

export function* handleGetReceipts() {
    try {
        const response = yield call(api.getReceipts);
        yield put(receiptActions.getReceipt.success(response.data));
    } catch (error) {
        yield put(receiptActions.getReceipt.failed(error.message));
    }
}

export function* handleCreateReceipt(action) {
    try {
        const response = yield call(api.createReceipt, action.payload);
        yield put(receiptActions.createReceipt.success(response.data));
    } catch (error) {
        yield put(receiptActions.createReceipt.failed(error.message));
    }
}

export function* handleUpdateReceiptPaypal(action) {
    try {
        const { id, data } = action.payload;
        const response = yield call(api.updateReceiptWithPaypalMethod, id, data);
        yield put(receiptActions.updateReceipt.success(response.data));
    } catch (error) {
        yield put(receiptActions.updateReceipt.failed(error.message));
    }
}

export function* handleUpdateReceiptMomo(action) {
    try {
        const { id, data } = action.payload;
        const response = yield call(api.updateReceiptWithMomoMethod, id, data);
        yield put(receiptActions.updateReceipt.success(response.data));
    } catch (error) {
        yield put(receiptActions.updateReceipt.failed(error.message));
    }
}

export function* handleDeleteReceipt(action) {
    try {
        const response = yield call(api.deleteReceipt, action.payload);
        yield put(receiptActions.deleteReceipt.success(response.data));
    } catch (error) {
        yield put(receiptActions.deleteReceipt.failed(error.message));
    }
}
